module.exports = __webpack_public_path__ + "static/media/LandingPage-pic02.1c991cff.png";